import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import RegistrationForm from "../../components/public-page/RegistrationForm";
import EnquiryForm from "../../components/public-page/EnquiryForm";
import PackageSelection from "../../components/public-page/PackageSelection";
import RegistrationReview from "../../components/public-page/RegistrationReview";
import RegistrationStepper from "../../components/public-page/RegistrationStepper";
import RegistrationMode from "../../components/public-page/RegistrationMode";
import RegistrationSuccess from "../../components/public-page/RegistrationSuccess";
import EnquirySuccess from "../../components/public-page/EnquirySuccess";
import BottomCards from "../../components/public-page/BottomCards";
import { toast } from "react-toastify";
import { getPublicSubscription, getPublicTenantDetails } from "../../../services/publicService";
import Faq from "../../components/public-page/Faq";
import Swal from "sweetalert2";

const PlayerRegistration = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [registrationData, setRegistrationData] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [pageType, setPageType] = useState("register");
  // register | enquiry | faq
  // Register Flow Only
  const [currentStage, setCurrentStage] = useState("basic");
  // basic | package | review | success
  // Enquiry Success
  const [enquirySuccess, setEnquirySuccess] = useState(false);
  const [tenanrData, setTenantData] = useState([]);

  const handleRegisterPage = () => {
    setPageType("register");
    setCurrentStage("basic");
  };

  const handleEnquiryPage = () => {
    setPageType("enquiry");
    setEnquirySuccess(false);
  };

  const handleBack = () => {
    setCurrentStage("package");
  };

  const handlePayment = () => { };

  const handleRegistrationSuccess = (data) => {
    Swal.fire(
      "Registration Completed Successfully!",
      "Your login PASSWORD has been sent to your registered E-MAIL address.",
      "success",
    );
    setRegistrationData(data);
    setCurrentStage("package");
  };

  const handlePackageSuccess = (pkg) => {
    console.log("Package Data Selected", pkg);
    setSelectedPackage(pkg);
    setCurrentStage("review");
  };

  const handlePaymentSuccess = (payment) => {
    setPaymentStatus(payment.paymentStatus);
    setCurrentStage("success");
  };

  async function fecthTenant(id) {
    const res = await getPublicTenantDetails(id);
    if (res) {
      setTenantData(res);
    }
  }

  useEffect(() => {
    if (id) {
      fecthTenant(id);
    }
  }, [id]);

  return (
    <div style={{ marginTop: 70 }}>
      {/* Registration Stepper */}
      {pageType === "register" && currentStage !== "success" && (
        <RegistrationStepper currentStage={currentStage} />
      )}

      {/* Register Form */}
      {pageType === "register" && currentStage === "basic" && (
        <RegistrationForm onSuccess={handleRegistrationSuccess} />
      )}

      {/* Package */}
      {pageType === "register" && currentStage === "package" && (
        <PackageSelection
          registrationData={registrationData}
          onSuccess={handlePackageSuccess}
        />
      )}

      {/* Review */}
      {pageType === "register" && currentStage === "review" && (
        <RegistrationReview
          registrationData={registrationData}
          selectedPackage={selectedPackage}
          onBack={() => setCurrentStage("package")}
          onSuccess={handlePaymentSuccess}
        />
      )}

      {/* Registration Success */}
      {pageType === "register" && currentStage === "success" && (
        <RegistrationSuccess paymentStatus={paymentStatus} />
      )}

      {/* Enquiry Form */}
      {pageType === "enquiry" && !enquirySuccess && (
        <EnquiryForm onSuccess={() => setEnquirySuccess(true)} />
      )}

      {pageType === "faq" && <Faq id={id} />}

      {/* Enquiry Success */}
      {pageType === "enquiry" && enquirySuccess && <EnquirySuccess />}

      {/* Bottom Cards */}
      {((pageType === "register" && currentStage !== "success") ||
        (pageType === "enquiry" && !enquirySuccess) ||
        pageType === "faq") && (
          <BottomCards
            activePage={pageType}
            onFaq={() => setPageType("faq")}
            onRegister={() => {
              setPageType("register");
              setCurrentStage("basic");
            }}
            onEnquiry={() => {
              setPageType("enquiry");
              setEnquirySuccess(false);
            }}
          />
        )}
    </div>
  );
};

export default PlayerRegistration;
